<template>
  <div>
    <div style="padding: 8px 0">カード単体 (item_sku 単体 / 非課税)</div>
    <ItemBox
      :link-url="items[0].linkUrl"
      :image-url="items[0].imageUrl"
      :brand-name="items[0].brandName"
      :item-name="items[0].itemName"
      :item-price="items[0].itemPrice"
      :is-including-tax="false"
      :has-multiple-item-skus="false"
      :is-delivery-item="false"
      :is-including-shipping-cost="false"
    />
    <div style="padding: 8px 0">カード単体 (item_sku 複数 / 非課税)</div>
    <ItemBox
      :link-url="items[0].linkUrl"
      :image-url="items[0].imageUrl"
      :brand-name="items[0].brandName"
      :item-name="items[0].itemName"
      :item-price="items[0].itemPrice"
      :is-including-tax="false"
      :has-multiple-item-skus="true"
      :is-delivery-item="false"
      :is-including-shipping-cost="false"
    />
    <div style="padding: 8px 0">カード単体 (item_sku 単体 / 税込み)</div>
    <ItemBox
      :link-url="items[0].linkUrl"
      :image-url="items[0].imageUrl"
      :brand-name="items[0].brandName"
      :item-name="items[0].itemName"
      :item-price="items[0].itemPrice"
      :is-including-tax="true"
      :has-multiple-item-skus="false"
      :is-delivery-item="false"
      :is-including-shipping-cost="false"
    />
    <div style="padding: 8px 0">カード単体 (item_sku 複数 / 税込み)</div>
    <ItemBox
      :link-url="items[0].linkUrl"
      :image-url="items[0].imageUrl"
      :brand-name="items[0].brandName"
      :item-name="items[0].itemName"
      :item-price="items[0].itemPrice"
      :is-including-tax="true"
      :has-multiple-item-skus="true"
      :is-delivery-item="false"
      :is-including-shipping-cost="false"
    />
    <div style="padding: 8px 0">カード単体 (配送商品 / 配送料別)</div>
    <ItemBox
      :link-url="items[0].linkUrl"
      :image-url="items[0].imageUrl"
      :brand-name="items[0].brandName"
      :item-name="items[0].itemName"
      :item-price="items[0].itemPrice"
      :is-including-tax="true"
      :has-multiple-item-skus="true"
      :is-delivery-item="true"
      :is-including-shipping-cost="false"
    />
    <div style="padding: 8px 0">カード単体 (配送商品 / 配送無料)</div>
    <ItemBox
      :link-url="items[0].linkUrl"
      :image-url="items[0].imageUrl"
      :brand-name="items[0].brandName"
      :item-name="items[0].itemName"
      :item-price="items[0].itemPrice"
      :is-including-tax="true"
      :has-multiple-item-skus="true"
      :is-delivery-item="true"
      :is-including-shipping-cost="true"
    />
    <div style="padding: 8px 0">カード型 (複数)</div>
    <ItemBoxes :items="items" :scrollable="false" />
    <div style="padding: 8px 0">カード型 (複数, スクロール可)</div>
    <ItemBoxes :items="items" :scrollable="true" />
    <div style="padding: 8px 0">接着型（単体）</div>
    <ItemBoxConnected
      :link-url="items[0].linkUrl"
      :image-url="items[0].imageUrl"
      :brand-name="items[0].brandName"
      :item-name="items[0].itemName"
      :item-price="items[0].itemPrice"
      :is-including-tax="true"
      :has-multiple-item-skus="true"
      :is-delivery-item="items[0].isDeliveryItem"
    />
    <div style="padding: 8px 0">接着型 (配送商品 / 配送料別)</div>
    <ItemBoxConnected
      :link-url="items[0].linkUrl"
      :image-url="items[0].imageUrl"
      :brand-name="items[0].brandName"
      :item-name="items[0].itemName"
      :item-price="items[0].itemPrice"
      :is-including-tax="true"
      :has-multiple-item-skus="true"
      :is-delivery-item="true"
      :is-including-shipping-cost="false"
    />
    <div style="padding: 8px 0">接着型 (配送商品 / 配送無料)</div>
    <ItemBoxConnected
      :link-url="items[0].linkUrl"
      :image-url="items[0].imageUrl"
      :brand-name="items[0].brandName"
      :item-name="items[0].itemName"
      :item-price="items[0].itemPrice"
      :is-including-tax="true"
      :has-multiple-item-skus="true"
      :is-delivery-item="true"
      :is-including-shipping-cost="true"
    />
    <div style="padding: 8px 0">接着型（複数）</div>
    <ItemBoxesConnected :items="items" />
    <div style="padding: 8px 0">Sku型 (単体・追加するボタンなし)</div>
    <div style="display: flex">
      <ItemSkuBox
        :link-url="items[0].linkUrl"
        :image-url="items[0].imageUrl"
        :brand-name="items[0].brandName"
        :item-name="items[0].itemName"
        :item-sku-name="items[0].itemSkuName"
        :item-sku-price="items[0].itemSkuPrice"
        :is-including-tax="false"
      />
      <ItemSkuBox
        :link-url="items[1].linkUrl"
        :image-url="items[1].imageUrl"
        :brand-name="items[1].brandName"
        :item-name="items[1].itemName"
        :item-sku-name="items[1].itemSkuName"
        :item-sku-price="items[1].itemSkuPrice"
        :is-including-tax="true"
      />
    </div>
    <div style="padding: 8px 0">Sku型 (単体・追加するボタンあり)</div>
    <div style="display: flex">
      <ItemSkuBox
        :link-url="items[0].linkUrl"
        :image-url="items[0].imageUrl"
        :brand-name="items[0].brandName"
        :item-name="items[0].itemName"
        :item-sku-name="items[0].itemSkuName"
        :item-sku-price="items[0].itemSkuPrice"
        :is-including-tax="false"
        :has-multiple-item-skus="true"
        :show-add-button="true"
        @clicked-add-button="clickItemSkuBoxAddButton(1)"
      />
      <ItemSkuBox
        :link-url="items[1].linkUrl"
        :image-url="items[1].imageUrl"
        :brand-name="items[1].brandName"
        :item-name="items[1].itemName"
        :item-sku-name="items[1].itemSkuName"
        :item-sku-price="items[1].itemSkuPrice"
        :is-including-tax="true"
        :has-multiple-item-skus="true"
        :show-add-button="true"
        @clicked-add-button="clickItemSkuBoxAddButton(2)"
      />
    </div>
    <div style="padding: 8px 0">Sku型 (複数, スクロール可)</div>
    <ItemSkuBoxes
      :item-skus="items"
      :scrollable="true"
      @clicked-add-button="clickItemSkuBoxesAddButton"
    />
  </div>
</template>
<script>
import ItemBox from '../../components/atoms/item_boxes/ItemBox.vue'
import ItemBoxes from '../../components/molecules/item_boxes/ItemBoxes.vue'
import ItemBoxConnected from '../../components/atoms/item_boxes/ItemBoxConnected.vue'
import ItemBoxesConnected from '../../components/molecules/item_boxes/ItemBoxesConnected.vue'
import ItemSkuBox from '../../components/atoms/item_boxes/ItemSkuBox.vue'
import ItemSkuBoxes from '../../components/molecules/item_boxes/ItemSkuBoxes.vue'
import imageUrl from '../../../../images/styleguide/summer_01.svg'
export default {
  components: {
    ItemBoxConnected,
    ItemBox,
    ItemBoxes,
    ItemBoxesConnected,
    ItemSkuBox,
    ItemSkuBoxes
  },
  data() {
    return {
      items: [
        {
          id: 1,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '1: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: false,
          hasMultipleItemSkus: false,
          isDeliveryItem: false,
          itemSkuName: '1: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        },
        {
          id: 2,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '2: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: true,
          hasMultipleItemSkus: false,
          isDeliveryItem: false,
          itemSkuName: '2: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        },
        {
          id: 3,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '3: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: false,
          hasMultipleItemSkus: true,
          isDeliveryItem: true,
          itemSkuName: '3: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        },
        {
          id: 4,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '4: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: true,
          hasMultipleItemSkus: false,
          isDeliveryItem: true,
          itemSkuName: '4: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        },
        {
          id: 5,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '5: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: false,
          hasMultipleItemSkus: false,
          isDeliveryItem: false,
          itemSkuName: '5: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        },
        {
          id: 6,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '6: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: true,
          hasMultipleItemSkus: true,
          isDeliveryItem: false,
          itemSkuName: '6: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        },
        {
          id: 7,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '7: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: false,
          hasMultipleItemSkus: false,
          isDeliveryItem: true,
          itemSkuName: '7: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        },
        {
          id: 8,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '8: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: true,
          hasMultipleItemSkus: false,
          isDeliveryItem: true,
          itemSkuName: '8: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        },
        {
          id: 9,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '9: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: false,
          hasMultipleItemSkus: true,
          isDeliveryItem: false,
          itemSkuName: '9: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        },
        {
          id: 10,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '10: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: true,
          hasMultipleItemSkus: false,
          isDeliveryItem: false,
          itemSkuName: '10: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        },
        {
          id: 11,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '11: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: false,
          hasMultipleItemSkus: false,
          isDeliveryItem: true,
          itemSkuName: '11: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        },
        {
          id: 12,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '12: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: true,
          hasMultipleItemSkus: true,
          isDeliveryItem: true,
          itemSkuName: '12: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        },
        {
          id: 13,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '13: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: false,
          hasMultipleItemSkus: false,
          isDeliveryItem: false,
          itemSkuName: '13: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        },
        {
          id: 14,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '14: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: true,
          hasMultipleItemSkus: false,
          isDeliveryItem: false,
          itemSkuName: '14: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        },
        {
          id: 15,
          linkUrl: '/styleguide',
          imageUrl,
          brandName: 'ブランド名',
          itemName:
            '15: 商品名が入ります。２行まで許容します。商品名が入ります。２行まで許容します。',
          itemPrice: '¥500',
          isIncludingTax: false,
          hasMultipleItemSkus: true,
          isDeliveryItem: true,
          itemSkuName: '15: sku名が入ります。sku名が入ります。',
          itemSkuPrice: '¥500',
          showAddButton: true
        }
      ]
    }
  },
  methods: {
    clickItemSkuBoxAddButton(id) {
      window.alert(
        `Sku型 (単体)の id:${id} の追加するボタンをクリックしました。`
      )
      event.preventDefault()
    },
    clickItemSkuBoxesAddButton(id) {
      window.alert(
        `Sku型 (複数, スクロール可) の id:${id} の追加するボタンをクリックしました。`
      )
      event.preventDefault()
    }
  }
}
</script>
